// extracted by mini-css-extract-plugin
export default {"background":"style_background__DEwlc","change":"style_change__CM30+"};